import whenDomReady from 'when-dom-ready';
whenDomReady().then(() => {
    let FormParent = document.querySelector('.js-send-callback');
    const url = `${window.location.origin}/api/`;
    if (!FormParent) {
        return;
    }
    const formName = FormParent.getAttribute('data-form-name');
    window.addEventListener('beforeunload', () => {
        const cookieConsent = document.cookie.match(new RegExp(`(^| )CookieScriptConsent=([^;]+)`));
        if (!cookieConsent)
            return;
        const consentJson = JSON.parse(cookieConsent[2]);
        if (!consentJson.categories.includes('targeting'))
            return;
        // re-get FormParent as it may have been removed from the DOM
        FormParent = document.querySelector('.js-send-callback');
        if (!FormParent)
            return;
        const fieldValues = [];
        FormParent.querySelectorAll('input').forEach(input => {
            if (input.value && input.value !== 'Submit') {
                fieldValues.push(`${input.name}¦${input.value}`);
            }
        });
        if (fieldValues.length) {
            fetch(`${url}/bizform/abandoned`, {
                method: 'POST',
                body: JSON.stringify({
                    formName: formName,
                    fieldValues,
                }),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            });
        }
    });
});
